import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-examination-grades',
  templateUrl: './examination-grades.component.html',
  styleUrls: ['./examination-grades.component.scss']
})
export class ExaminationGradesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
